<app-supplier-verification-dialog></app-supplier-verification-dialog>
<nav class="fixed z-30 w-full bg_color pt-3 px-2">
  <div class="card_color rounded-lg p-4 py-4 lg:py-2 px-3 lg:px-5 lg:pl-5">
    <div class="flex justify-between items-center">
      <div class="flex justify-start items-center">
        <!-- Sidebar Toggle Button -->

        <!-- Logo -->
        <a
          [routerLink]="['/']"
          routerLinkActive="router-link-active"
          class="logo text-md font-semibold flex items-center lg:mr-1.5"
        >
          <img
            class="logo mr-2 object-contain"
            style="width: 150px; height: 45px"
            [src]="logo ? logo : 'assets/images/logo.png'"
            *ngIf="!showLoadSpin"
            [routerLink]="['/']"
            alt="Casino Logo"
          />
        </a>
      </div>
      <!--IS NOT LoggedIn-->
      <div *ngIf="!isLoggedIn" class="flex items-center hidden lg:block">
        <!-- Login Button -->
        <button
          type="button"
          (click)="changeLoginModalVisibility(true)"
          class="open-login-modal text_color_customize border-2 border_color_customize font-medium rounded-lg text-sm px-5 py-2 mr-2 text-center inline-flex items-center shadow-md shadow-gray-300 hover:scale-[1.02] transition-transform"
        >
          {{ "lobby.login" | translate }}
        </button>

        <button
          type="button"
          (click)="changeShowCreateAccountModal(true)"
          class="open-register-modal template_color_customize text_black font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center shadow-md shadow-gray-300 hover:scale-[1.02] transition-transform"
        >
          {{ "lobby.register" | translate }}
        </button>
      </div>

      <!--IS LoggedIn-->
      <app-my-credits
        [wallet]="wallet"
        [isLoggedIn]="isLoggedIn"
        *ngIf="isLoggedIn"
      ></app-my-credits>

      <!-- Right Section: Language Selector and Buttons -->
      <div
        *ngIf="isLoggedIn"
        class="flex items-center space-x-4 hidden lg:flex"
      >
        <!-- Añadimos un espacio horizontal entre los elementos -->

        <!-- Button 1: Notification Icon -->
        <notificationes-cajero
          (onClose)="hideCajero()"
          (onToggle)="toggleCajero()"
          [newNoti]="newNotiCajeros && !isPCPlayer"
          [show]="showCajero && !isPCPlayer"
          [isDisabled]="disabledButtons"
        ></notificationes-cajero>
        <notificationes-bonos
          (onClose)="hideBonos()"
          (onToggle)="toggleBonos()"
          [newNoti]="newNotiBonos && !isPCPlayer"
          [show]="showBonos && !isPCPlayer"
          [isDisabled]="disabledButtons"
        ></notificationes-bonos>

        <!-- Button 2: User Menu -->
        <app-profile-icon [isPCPlayer]="isPCPlayer"></app-profile-icon>
      </div>
    </div>
  </div>
</nav>

<!-- ## nav mobile -->
<app-bottom-menu
  [newNotiBonos]="newNotiBonos"
  [newNotiTransactions]="newNotiCajeros"
  [wallet]="wallet"
  [social_networks]="social_networks"
  [isPcPlayer]="isPCPlayer"
></app-bottom-menu>
<!-- NEW SIDEBAR -->
<div class="flex bg_color h-screen">
  <!-- SIDE BAR INICIO -->

  <app-sidebar
    [social_networks]="social_networks"
    [isSidebarExpanded]="isSidebarExpanded"
  ></app-sidebar>
  <!-- <app-menu
      (toggleMenu)="toggleMenu($event)"
      [social_networks]="social_networks"
    ></app-menu> -->

  <!-- SIDE BAR FINAL -->

  <div
    class="hidden fixed inset-0 z-10 card_color opacity-50"
    id="sidebarBackdrop"
  ></div>
  <div
    id="main-content"
    class="h-full w-full bg_color relative overflow-y-auto"
  >
    <main>
      <div class="px-2 md:px-2 pt-8 md:pt-5 mt-16">
        <!-- Solo visible en vista móvil -->
        <router-outlet></router-outlet>
        <!--fin tabla-------------->
      </div>
    </main>
  </div>
</div>

<app-create-account-modal
  [showModal]="showCreateAccountModal"
  (hideModal)="changeShowCreateAccountModal($event)"
></app-create-account-modal>
<app-login-modal
  [showModal]="showLoginModal"
  (hideModal)="changeLoginModalVisibility($event)"
  (noAccount)="noAccount()"
  (loginSuccess)="handleLoginSuccess()"
></app-login-modal>
<style>
  :host ::ng-deep .custom-spinner .p-progress-spinner-circle {
    animation: custom-progress-spinner-dash 1.5s ease-in-out infinite,
      custom-progress-spinner-color 6s ease-in-out infinite;
  }

  @keyframes custom-progress-spinner-color {
    100%,
    0% {
      stroke: #85838d;
    }

    40% {
      stroke: #85838d;
    }

    66% {
      stroke: #85838d;
    }

    80%,
    90% {
      stroke: #85838d;
    }
  }

  @keyframes custom-progress-spinner-dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }

    50% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -35px;
    }

    100% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -124px;
    }
  }
</style>
